export const HOST_URL = process.env.REACT_APP_API_SERVER_HOST || "";
export const BUILD_TARGET = process.env.REACT_APP_BUILD_TARGET || "dev";
export const API_KEY = process.env.REACT_APP_API_KEY || "";

export const GOOGLE_CLIENTID = process.env.REACT_APP_GOOGLE_CLIENTID || "";
export const SECRET_GOOGLE_CLIENTID =
  process.env.REACT_APP_SECRET_GOOGLE_CLIENTID || "";

export const FB_PIXEL_ID =
  process.env.REACT_APP_FB_PIXEL_ID || "";

export const isDev = BUILD_TARGET === "dev";
